import React, { useEffect, useState } from 'react'
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
  Input,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner
} from 'reactstrap'
import styled from 'styled-components'
// core components
import SimpleHeader from 'components/Headers/SimpleHeader.js'
import { useHistory } from 'react-router-dom'
import { useDashboardContext } from '../../../contexts/DashboardContext'
// import { useActivationContext } from '../../../contexts/ActivationContext'

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

function PlanSelection({ location }) {
  const {
    msisdn,
    sim,
    email,
    password,
    subscriberDetails,
    mobileType,
    phoneNumber,
    address,
    portInNumber,
    activationType,
    accountNumber,
    acctCostCtrId,
    acctEmail,
    createAccount,
    idDetails
  } = location.state
  const { getOnboardProductList } = useDashboardContext() 
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [planDetails, setPlanDetails] = useState([])
  const [productType, setProductType] = useState(null)
  const [planId, setPlanId] = useState(null)
  const [planName, setPlanName] = useState(null)
  const [planDescr, setPlanDescr] = useState(null)
  const [planValue, setPlanValue] = useState(null)
  const [productList, setProductList] = useState([])
  const [showProductList, setShowProductList] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [voucherCode, setVoucherCode] = useState(null)


  const history = useHistory()

  const onSubmit = () => {
    console.log('planId: ', planId)
    const planDetails = {
      planId: planId,
      planName: planName,
      planDescr: planDescr,
      planValue: planValue,
      voucherCode: voucherCode
    }

    history.push({
      pathname: '/admin/review',
      state: {
        msisdn,
        sim,
        email,
        password,
        subscriberDetails,
        mobileType,
        phoneNumber,
        address,
        portInNumber,
        activationType,
        accountNumber,
        acctCostCtrId,
        acctEmail,
        createAccount,
        idDetails,
        planDetails: planDetails
      }
    })
  }

  useEffect(() => {
    const loadProductList = async (type) => {
      console.log('type: ', type)
      setLoading(true)
      await getOnboardProductList({
        portIn: portInNumber ? true : false,
      })
      .then((res) => {
        setLoading(false)
        console.log('loadProductList: ', res)
        setProductList(res)
      })
      .catch((err) => {
        setLoading(false)
        setError(true)
        setErrorMessage('Something went wrong. Please try again later.')
      })
    }
    loadProductList()
  }, [getOnboardProductList])

  const productListToggle = () => {
    setShowProductList((prevState) => !prevState)
  }

  useEffect(() => {
    if (planId !== null) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [productType, planId])

  return (
    <>
      <SimpleHeader name="Select A Plan" />
      <Container
        fluid
        className="d-flex align-items-center justify-content-start flex-column"
      >
         <Card style={{ width: '100%' }}>
           <CardHeader>
             <Row className="align-items-center">
               <Col xs="8">
                 <h3 className="mb-0 text-primary neue-bold letter-2">
                   Plan Selection
                 </h3>
               </Col>
             </Row>
           </CardHeader>
           <CardBody className="text-primary">
            <Form
              onSubmit={(e) => {
                e.preventDefault()
                onSubmit()
              }}
            >
              <div className="pl-lg-4">
                {loading ? (
                  <SpinnerWrapper>
                    <Spinner />
                  </SpinnerWrapper>
                ) : (
                  <FormGroup row>
                    <Label className="letter-4" htmlFor="select-plan" md={2}>
                      Select Plan
                    </Label>
                      <Col md={6}>
                      <Dropdown
                        style={{ width: '100%' }}
                        isOpen={showProductList}
                        toggle={productListToggle}
                      >
                        <DropdownToggle color="light" caret>
                          {planId ? productList.find(i => i.productId === planId)?.name : "Select a Plan"}
                        </DropdownToggle>
                        <DropdownMenu>
                          {productList?.map((list) => {
                            return (
                              <DropdownItem
                                key={list.productId}
                                onClick={() => {
                                  setPlanId(list.productId)
                                  setPlanName(list.name)
                                  setPlanDescr(list.description)
                                  setPlanValue(list.discountedPrice)
                                  setVoucherCode(list.campaignDetails?.[0]?.voucherPin || null)
                                }}
                              >
                                {list.name}
                              </DropdownItem>
                            )
                          })}
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                  </FormGroup>
                )}
                {planId && (
                  <FormGroup row>
                    <Label className="letter-4 text-primary" htmlFor="select-plan" md={2}>
                      Plan Details
                    </Label>
                    <Col md={10}>
                      <Table className='text-primary letter-4'>
                        <thead>
                          <tr>
                            <th>Plan Name</th>
                            <th>Plan Descr</th>
                            <th>Plan Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{productList.find(i => i.productId === planId)?.name}</td>
                            <td>{productList.find(i => i.productId === planId)?.description}</td>
                            <td>
                              {productList.find(i => i.productId === planId)?.discountedPrice &&
                              productList.find(i => i.productId === planId)?.discountedPrice !==
                              productList.find(i => i.productId === planId)?.price &&
                              productList.find(i => i.productId === planId)?.discountedPrice !== undefined ? (
                                <>
                                <span style={{ textDecoration: 'line-through' }}>
                                  ${productList.find(i => i.productId === planId)?.price}
                                </span>
                                {' '} ${productList.find(i => i.productId === planId)?.discountedPrice}
                                </>
                              ) : (
                                <>
                                ${productList.find(i => i.productId === planId)?.price}
                                </>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </FormGroup>
                )}
                <Button color="secondary" className="" type="submit" disabled={!isValid}>
                  Submit
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </>
  )
}  

export default PlanSelection